/*
 * @Author: Teemo Ding
 * @Date: 2021-09-09 16:11:10
 * @LastEditTime: 2021-10-29 14:49:45
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/components/TableColSelector/ColSelector.tsx
 */
import React from 'react';
import css from './selector.less';
import { PopOver, Checkbox } from 'src/components/Antd';
import GlobalButton from '@/src/components/Antd/Button/Button';
import { SettingOutlined, UndoOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { getI18nFromGeneral } from '@/src/tools/tools';
const Selector = (props) => {
  const { allColumns, onChange, setReset } = props;
  //console.log('allColumns', allColumns);
  const menuThSet = (
    <div className={css.setReset} onClick={setReset}>
      <UndoOutlined />
      <span className={css.setResetText}>
        {getI18nFromGeneral('general.tableColSelector.reset')}
      </span>
    </div>
  );
  const checkboxChange = (r, column, e) => {
    e.stopPropagation();
    const columnArray = _.cloneDeep(allColumns);
    columnArray[
      allColumns.findIndex((item) => item.key == column.key)
    ].default = r; //default 来控制现实col
    //teemo ->
    onChange(columnArray);
  };
  const setItem = allColumns.map((column) => {
    return (
      column.optional && (
        <div className={css.setItem} key={column.key}>
          <Checkbox
            onChange={(r, e) => checkboxChange(r, column, e)}
            checked={column.default}>
            {column.textTitle || column.title}
          </Checkbox>
        </div>
      )
    );
  });
  const setItemText = <div className={css.setItemContain}>{setItem}</div>;
  return (
    <div className={css.tableSet}>
      <PopOver
        overlay={setItemText}
        trigger={['click']}
        title={menuThSet}
        overlayClassName={css.overlayClassName}
        placement='bottomRight'>
        <GlobalButton
          className={css.tableSetButton}
          icon={<SettingOutlined />}></GlobalButton>
      </PopOver>
    </div>
  );
};
export default Selector;
